<template>
  <div>
    <div class='top'>检查人员信息填写</div>
    <van-cell-group>
      <van-field v-model="name" required clearable label="姓名" placeholder="请输入姓名" />
      <van-field v-model="idCard" clearable label="身份证号" placeholder="请输入身份证号" />

      <van-field v-model="code" clearable label="学籍号" placeholder="请输入学籍号" />
      <van-field v-model="phone" type="number" clearable label="手机号" placeholder="请输入手机号" />
      <div class="tip">*身份证号码,学籍号与手机号码须至少填写一项</div>
      <van-button type="info" @click="goQuery" class="btn">
        确定
      </van-button>
    </van-cell-group>
    <div class='tip-bottom'>
      <div class='tip-xieyi'><input type="checkbox" :checked="isCheck" @click="checkXieyi">我已阅读并同意 <span
          class="xieyi-href" @click="goXieyi">用户协议及隐私政策</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "query",
  data() {
    return {
      name: '',
      idCard: '',
      phone: '',
      accountId: '',
      code: '',
      isCheck: false,
      accountTitle: '',
      wstToken: '',
      isWst: false,
    };
  },
  mounted() {
    // this.wstToken = this.$route.query.wstToken || wstToken;
    /* if(this.wstToken!=null && this.wstToken!=''){
      this.isWst = true;
      this.getWstInfo();
    }*/
    this.openId = this.$route.query.openId;
    this.accountId = this.$route.query.accountId;
    this.getTitle();
  },
  methods: {
    async getWstInfo() {
      let auth = this.$createAuth(this.$md5);
      let data = {
        token: this.wstToken,
        auth: auth.code,
        time: auth.time
      };
      let result = await this.$http.get(this.$url.queryWstUser, data);
      if (result.message === 'Error: Miss auth parameter.') {
        this.getWstInfo();
      } else {
        let info = result.data.data;
        this.name = info["perUserVo.name"];
        this.idCard = info["perUserVo.credentNo"];
        this.phone = info["perUserVo.bindPhone"];
      }
    },
    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getTitle, {
        accountId: this.accountId,
        auth: auth.code,
        time: auth.time
      })
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data?.title
      }
      /* if(result.data.accountTitle!=null &&  result.data.accountTitle!=""){
        this.accountTitle = result.data.accountTitle;
        this.showAccountTitle = true;
      }
      if(this.wstToken!=null && this.wstToken!=''){
        document.title = '眼健康在线';
      } */
    },
    checkXieyi() {
      this.isCheck = !this.isCheck;
    },
    goXieyi() {
      this.$router.push(`/xieyi`);
    },
    async goQuery() {
      if (this.name == "") {
        this.$toast("请填写姓名！");
        return;
      } else {
        /*var nameReg = /^[\u4E00-\u9FA5]{2,4}$/;
        if (!nameReg.test(this.name)) {
          this.$toast("姓名不符合规则")
          return ;
        }*/
      }
      if (this.idCard == "" && this.phone == "" && this.code == "") {
        this.$toast("身份证号码,学籍号与手机号码须至少填写一项！");
        return;
      }

      if (this.idCard != "") {
        let yz1 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(this.idCard);
        let yz2 = /(^[a-zA-Z][0-9]{9})|(^[A-Z][0-9]{8})|(^[A-Z][0-9]{6}[(（][0-9a-zA-z][)）])$/.test(this.idCard);
        if (!yz1 && !yz2) {
          this.$toast("身份证号填写错误！");
          return;
        }
      }
      if (this.phone != "") {
        let testPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[0123456789]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(this.phone)
        if (!testPhone) {
          this.$toast("手机号填写错误！");
          return;
        }
      }
      if (this.isCheck) {
        let hospitalId = this.$route.query.hospitalId;
        if (hospitalId == null || hospitalId == 'null' || typeof (hospitalId) == undefined) hospitalId = '';
        this.$router.push(`/recordCheckPerson?name=${this.name}&phone=${this.phone}&accountId=${this.$route.query.accountId}&idCard=${this.idCard}&code=${this.code}&hospitalId=${hospitalId}`);
      } else {
        this.$toast("请阅读并同意用户协议及隐私政策")
      }

    }
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.btn {
  width: 5rem;
  margin-top: 1rem;
  border: none;
  background: #5CC4AB;
}

.tip {
  padding: 0.3rem;
  text-align: left;
  color: #999;
}

.tip-bottom {
  margin: 0.1rem 0.3rem;
  text-align: left;
  height: 0.6rem;
  line-height: 0.6rem;

  .tip-info {
    color: #999999;
    font-size: 0.26rem;
  }

  .tip-query {
    margin-top: 1rem;
    text-align: center;
  }

  .tip-xieyi {
    position: fixed;
    padding: 0.5rem 0;
    left: 0;
    bottom: 0.3rem;
    width: 100%;
    background: #fff;
    text-align: center;
    font-size: 0.28rem;
  }
}

.xieyi-href {
  color: #0a6aa1;
}

input[type=checkbox] {
  cursor: pointer;
  position: relative;
  width: 0.3rem;
  height: 0.3rem;
  font-size: 0.24rem;
  line-height: 0.3rem;
  border: 1px solid #5CC4AB;
}

input[type=checkbox]::after {
  position: absolute;
  top: 0;
  color: #000;
  width: 0.3rem;
  height: 0.3rem;
  display: inline-block;
  visibility: visible;
  padding-left: 0px;
  text-align: center;
  content: ' ';
  border-radius: 3px;
  line-height: 0.3rem;
}

input[type=checkbox]:checked::after {
  content: "✓";
  color: #fff;
  font-size: 0.24rem;
  font-weight: bold;
  background-color: #5CC4AB;
  line-height: 0.3rem;
}
</style>
